var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting-edit-controls row"},[_c('div',{staticClass:"col"},[_c('create-meeting-button'),_vm._v(" "),_c('meeting-edit-button'),_vm._v(" "),_c('delete-meeting-button'),_vm._v(" "),_c('delete-meeting-modal')],1),_vm._v(" "),_c('div',{staticClass:"col text-end"},[_c('mode-toggle-switch')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }